import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IStateParamsService } from 'angular-ui-router';

interface IPageCb0004 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    prvMultiOccurrenceOptions: IMultiOccurrenceOptions;
    tymMultiOccurrenceOptions: IMultiOccurrenceOptions;
    tydMultiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
}

/* @ngInject */
export default function Cb0004Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    Pagination: IPaginationClass,
    Menu: IMenuClass,
    MenuItemForage: IMenuItemForageClass,
    cb0050Route: IRoute,
    cb2001Route: IRoute,
    cb0026Route: IRoute,
    cb0031Route: IRoute,
    $stateParams: IStateParamsService
) {
    const vm: IPageCb0004 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    const forageCB0050 = new MenuItemForage(
        'LBL_RESERVE',
        cb0050Route.NAME,
        (rowData: any) => ({
            id: $stateParams.prucleint,
            prucleint: $stateParams.prucleint,
            vaesysnatctb: vm.valeursEcran.vaesysnatctbcri,
            annfindeb: vm.valeursEcran.pecanncri,
            menuId: $stateParams.menuId
        }),
        {
            fonction: 'RESERVES',
            icon: 'exit_to_app',
            iconButton: true,
            hidden: (rowData: any) => rowData.mntrsv === null
        }
    )

    vm.tymMultiOccurrenceOptions = {
        bloc: 'tym',
        colonnesVisibles: [
            { nom: 'tyhdsc', largeur: 250 },
            { nom: 'ctvmntsum', largeur: 130 },
            { nom: 'ctvmntimp', largeur: 120, total: true },
            { nom: 'mntrsv', largeur: 120, menu: [forageCB0050] }
        ],
        pagination: new Pagination({
            nombreElementPage: 5,
            nbElementsPossibles: [5, 10, 25]
        })
    };

    vm.prvMultiOccurrenceOptions = {
        bloc: 'prv',
        fonctions: {
            rechercheCollapsable: false,
            effaceCriteres: true
        },
        actionsMoreLigne: new Menu([
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0026',
                cb0026Route.NAME,
                (rowData:any) => ({
                    id: $stateParams.prucleint,
                    typapp: 'PRV',
                    typbdg: 'DB',
                    prucleint: $stateParams.prucleint,
                    prbcleint: rowData.prbcleint,
                    prvcleint: rowData.prvcleint,
                    vaesysnatctb: $stateParams.vaesysnatctb,
                    pecann: $stateParams.pecann,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_ACT_FORAGE_CB0026',
                    icon: 'exit_to_app'
                }
            ),
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0031',
                cb0031Route.NAME,
                (rowData:any) => ({
                    id: $stateParams.prucleint,
                    typapp: 'PRV',
                    typbdg: 'DB',
                    prucleint: $stateParams.prucleint,
                    prbcleint: rowData.prbcleint,
                    prvcleint: rowData.prvcleint,
                    vaesysnatctb: $stateParams.vaesysnatctb,
                    pecann: $stateParams.pecann,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_ACT_FORAGE_CB0031',
                    icon: 'exit_to_app'
                }
            )
        ]),
        criteresSuggeres: new Formulaire([
            new FormulaireItem('pecanncri', {
                default: vm.valeursEcran.pecanncri,
                readonly: true
            }),
            new FormulaireItem('indcleintcri', {
                default: vm.valeursEcran.indcleintcri,
                readonly: true
            }),
            new FormulaireItem('vaesysnatctbcri', {
                default: vm.valeursEcran.vaesysnatctb,
                readonly: true
            }),
            new FormulaireItem('flgexcina', {
                default: 0
            })
        ]),
        colonnesVisibles: [
            { nom: 'cptcod', largeur: 100 },
            { nom: 'cptdsc', largeur: 250 },
            { nom: 'cifcod', largeur: 100 },
            { nom: 'cifdsc', largeur: 250 },
            { nom: 'unacod', largeur: 100 },
            { nom: 'unadsc', largeur: 250 }
        ],
        colonnesFixesDroite: [
            { nom: 'mntsum', largeur: 130, total: true }
        ],
        pagination: new Pagination({
            nombreElementPage: 5,
            nbElementsPossibles: [5, 10, 25]
        }),
        colonnesCachees: [ 'prbcleint' ],
        multiOccurrenceOptionsEnfant: vm.tymMultiOccurrenceOptions
    };

    vm.tydMultiOccurrenceOptions = {
        bloc: 'tyd',
        actionsRangeeDroite: new Menu([
            new MenuItemForage(
                'LBL_DETAIL',
                cb2001Route.NAME,
                (rowData: any) => ({
                    type: 'PRV',
                    prucleint: $stateParams.prucleint,
                    prbcleint: rowData.prbcleint,
                    prvcleint: rowData.prvcleint,
                    vaesysnatctb: vm.valeursEcran.vaesysnatctbcri,
                    tymcleint: rowData.tymcleint,
                    tydcleint: rowData.tydcleint,
                    pecann: vm.valeursEcran.pecanncri
                }),
                {
                    icon: 'exit_to_app',
                    fonction: 'BOUDOC',
                    iconButton: true
                }
            )
        ]),
        colonnesVisibles: [
            { nom: 'tyddsc', largeur: 130 },
            { nom: 'ctvmntsum', largeur: 120 }
        ],
        colonnesCachees: [
            'prvcleint',
            'prbcleint',
            'tymcleint',
            'tydcleint'
        ]
    };
}
